import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { blogPosts } from './blogData';
import EVMGalaxy from './EVMGalaxy';
// import CallVsDelegatecall from './CallVsDelegatecall';
import './Blog.css';

// Posts that render only an embedded component (no HTML content from blogData)
const POSTS_FULL_COMPONENT = ['evm-storage' /* , 'calls-and-delegatecall' */];

/**
 * Renders full-component posts (the entire article is a React component)
 */
function FullComponentContent({ postId }) {
  if (postId === 'evm-storage') {
    return <EVMGalaxy />;
  }
  // if (postId === 'calls-and-delegatecall') {
  //   return <CallVsDelegatecall />;
  // }
  return null;
}

/**
 * Modal for full article view. Closes on overlay click, close button, or ESC.
 * For evm-storage post, content is split at BLOG_EMBED_MARKER and EVM Galaxy is rendered in between.
 */
function ArticleModal({ postId, onClose }) {
  const post = postId ? blogPosts[postId] : null;

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    if (postId) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', handleEscape);
      return () => {
        document.body.style.overflow = '';
        document.removeEventListener('keydown', handleEscape);
      };
    }
  }, [postId, onClose]);

  if (!postId || !post) return null;

  const isFullComponent = POSTS_FULL_COMPONENT.includes(postId);
  const overlayBg = post.overlayBackground || 'default';

  // For full-component posts, render the component as the entire body (no HTML content)
  if (isFullComponent) {
    const modalContent = (
      <div
        className={`blog-modal-overlay blog-modal-overlay--${overlayBg} blog-modal-active`}
        onClick={onClose}
        role="dialog"
        aria-modal="true"
        aria-labelledby="blog-modal-title"
      >
        <div
          className={`blog-modal-container blog-modal-container--${overlayBg} blog-modal-container--full-article`}
          onClick={(e) => e.stopPropagation()}
          style={{ maxWidth: '100%', width: '100%', padding: 0 }}
        >
          <button
            type="button"
            className="blog-modal-close"
            onClick={onClose}
            aria-label="Close modal"
            style={{ 
              position: 'fixed', 
              top: '20px', 
              right: '20px', 
              zIndex: 1000,
              background: 'rgba(139, 92, 246, 0.3)',
              border: '1px solid rgba(139, 92, 246, 0.5)',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              fontSize: '24px',
              color: '#fff',
              cursor: 'pointer'
            }}
          >
            ×
          </button>
          <div className="blog-modal-body" style={{ padding: 0 }}>
            <FullComponentContent postId={postId} />
          </div>
        </div>
      </div>
    );
    return ReactDOM.createPortal(modalContent, document.body);
  }

  const modalContent = (
    <div
      className={`blog-modal-overlay blog-modal-overlay--${overlayBg} blog-modal-active`}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="blog-modal-title"
    >
      <div
        className={`blog-modal-container blog-modal-container--${overlayBg}`}
        onClick={(e) => e.stopPropagation()}
      >
        <header className="blog-modal-header">
          <button
            type="button"
            className="blog-modal-close"
            onClick={onClose}
            aria-label="Close modal"
          >
            ×
          </button>
          <div className="blog-modal-meta">
            <span className="blog-card-date">
              <span aria-hidden="true">📅</span> {post.date}
            </span>
            <span className="blog-card-category">{post.category}</span>
            <span className="blog-card-read-time">{post.readTime}</span>
          </div>
          <h1 id="blog-modal-title" className="blog-modal-title">
            {post.title}
          </h1>
          {post.tags?.length > 0 && (
            <div className="blog-modal-tags">
              {post.tags.map((tag) => (
                <span key={tag} className="blog-card-tag">
                  {tag}
                </span>
              ))}
            </div>
          )}
        </header>
        <div className="blog-modal-body">
          <div
            className="blog-article-content"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}

export default ArticleModal;
